import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'

const spreadsheetMainImages: Record<string, string> = import.meta.glob('@/assets/landing/spreadsheet-main/*.webp', {
	eager: true,
	import: 'default',
})

const schema: LandingScreenSchema = {
	config: {
		funnelFeatureFlag: 'creatives_spreadsheet',
	},

	order: ['LandingHead', 'LandingTitle', 'LandingSubtitle', 'LandingImage', 'LandingProgressLoader', 'LandingFooter'],

	components: {
		LandingTitle: ({ $t }): LandingComponentsConfig['LandingTitle'] => ({
			title: $t('pages.landing.main_funnel.title_fasting'),
			size: 'large',
			uppercase: true,
		}),

		LandingSubtitle: ({ $t }): LandingComponentsConfig['LandingSubtitle'] => ({
			title: $t('pages.landing.main_funnel.subtitle_fasting', {
				personalised_plan: `<b>${$t('pages.landing.main_funnel.personalised_plan')}</b>`,
			}),
			uppercase: true,
		}),

		LandingImage: ({ ctx }): LandingComponentsConfig['LandingImage'] => {
			const img =
				Object.entries(spreadsheetMainImages).find(([k]) => k.includes(`${ctx.language}.webp`))?.[1] ??
				Object.entries(spreadsheetMainImages).find(([k]) => k.includes('en.webp'))?.[1]
			return {
				img,
				customStyles: {
					height: '42vh',
				},
			}
		},

		LandingProgressLoader: (): LandingComponentsConfig['LandingProgressLoader'] => ({
			duration: 3500,
		}),
	},
}

export default schema
